import { Box } from "@mui/system";
import GenericFilterBox from "../common/GenericFilterBox";
import FormInput from "../common/FormInput";
import { VehicleInspection } from "./Types";
import { nameof } from "../common/ObjectUtils";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import * as MuiIcons from "@mui/icons-material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  ColDef,
  Grid,
  ICellRendererParams,
  IServerSideGetRowsParams,
} from "ag-grid-community";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import * as Mui from "@mui/material";
import EmptyStateGrid from "../common/EmptyStateGrid";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { useContext, useEffect, useRef, useState } from "react";
import { ContextOperation } from "../../context/OperationContext";
import VehicleInspectionService from "./sevices/VehicleInspection.action";
import { AgGridReact } from "ag-grid-react";
import dayjs from "dayjs";
import { saveFileFromResponse } from "../../utils";
import useSnackbar from "../../hooks/useSnackbar";
import useToggle from "../../hooks/useToggle";
import { ConfirmationModalTransportator } from "../transportator/ConfirmationModalTransportator";
import CreateVehicleInspection from "./CreateVehicleInspection";
import EmptyState from "../../../../util/component/EmptyState";
import EditVehcleInspection from "./EditVehicleInspection";
import { useHasScope } from "../../../../config/globalConfig";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const VehicleInspectionTable = () => {
  const form = useForm<any>({
    defaultValues: {
      // inspectionDateFrom:null,
      // inspectionDateTo:null
    },
  });
  const t = useOperationTranslation();
  const hasScope = useHasScope;
  const { tenant } = useContext(ContextOperation);
  const [gridApi, setGridApi] = useState<any>(null);
  const [length, setLength] = useState<number>(0);
  const { setLoading } = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const [showDelete, toggleDelete] = useToggle();
  const [showEdit, toggleEdit] = useToggle();
  const [showCreate, toggleCreate] = useToggle();
  const [open, toggleOpen] = useToggle();
  const [vehicleId, setVehicleId] = useState<number>(0);
  const [refresh, setRefreshPage] = useToggle();
  const [vehicleSelected, setVehicleSelected] = useState<any>({});
  const [checkIsDelete, setCheckIsDelete] = useState<string>("");

  const [pageState, setPageState] = useState<any>({
    data: [],
    vehicleId: -1,
  });

  const fieldFunction = () => {
    if (
      hasScope("SCOPE_UPDATE_MDVEHICLE_INSPECTION") ||
      hasScope("SCOPE_DELETE_MDVEHICLE_INSPECTION") ||
      hasScope("SCOPE_CREATE_MDVEHICLE_INSPECTION")
    )
      return "_actions";
    else return "";
  };

  const vehicleColumns: ColDef[] = [
    {
      field: nameof<VehicleInspection.VehicleInspectionList>("inspectionDate"),
      headerName: t("vehicleInspection.crate.inspectionDate"),
      flex: 1,
      cellRenderer: (
        params: ICellRendererParams<VehicleInspection.VehicleInspectionList>
      ) => {
        return (
          <>
            {dayjs(`${params.data?.inspectionDate}`).format(
              "DD/MM/YYYY HH:mm"
            )}
          </>
        );
      },
    },
    {
      field: nameof<VehicleInspection.VehicleInspectionList>("kmInspection"),
      headerName: t("vehicleInspection.crate.kmInspection"),
      flex: 1,
    },

    {
      field: fieldFunction(),
      headerName: '',
      sortable: false,
      flex: 0.7,
      maxWidth:80,
      cellStyle: {
        display: 'flex',
        alignItems: 'center'
      },
      cellRenderer: (props: ICellRendererParams<any>) => {
        return (
          <>
            {pageState.data.length > 0 && (
              // <>
              <Mui.Stack direction="row">
                {hasScope("SCOPE_UPDATE_MDVEHICLE_INSPECTION") && (
                  <Mui.Tooltip title={t("tooltipTitle.edit")}>
                    <Mui.Button
                      variant="text"
                      size="icon"
                      color="accent"
                      disabled={
                        pageState.data[0].id === props.data.id ? false : true
                      }
                    >
                      <EditIcon onClick={() => openEditModal(props.data)} />
                    </Mui.Button>
                  </Mui.Tooltip>
                )}
                {/* {hasScope("SCOPE_DELETE_MDVEHICLE_INSPECTION") && (
                  <Mui.Tooltip title={t("tooltipTitle.delete")}>
                    <Mui.Button variant="text" size="icon" color="accent">
                      <MuiIcons.Delete
                        onClick={() => {
                          openDeleteModal(props.data?.id);
                        }}
                      />
                    </Mui.Button>
                  </Mui.Tooltip>
                )} */}
              </Mui.Stack>

              // </>
            )}
          </>
        );
      },
    },
  ];

  function managerData(response: any) {
    let rows: any[] = [];
    response.inspections.forEach((element: any) => {
      let row = {
        kmInspection: element.kmInspection,
        inspectionDate: element.inspectionDate,
        id: element.id,
      };
      rows.push(row);
    });
    return rows;
  }

  const repairedStatusList = () => {
    setLoading(true);

    let formValues = form.getValues();

    for (const key of Object.keys(formValues)) {
        if(typeof formValues[key] === 'string'){
          formValues[key] = formValues[key].trim();
        }
    }

    VehicleInspectionService.list
      .getVegicleInspection(tenant, formValues)
      .then((response: any) => {
        setPageState({
          data: managerData(response),
          vehicleId: response.vehicleId,
        });
        setLoading(false);
        setLength(response.inspections.length);
      })
      .catch((error: any) => {
        if (error.response) {
          toggleOpen();
          setCheckIsDelete("test");
        } else if (error.request) {
          //snackbar.show("error","tetetet")
          setLoading(false);
        } else {
        }
        setLoading(false);
      });
  };
  const onSubmit = (e: any) => {
    repairedStatusList();
  };

  const onReset = () => {
    form.reset();
    setLength(0);
    setPageState({ data: [], vehicleId: -1 });
  };

  const MyCustomNoRowsOverlay = () => (
    <EmptyState
      title={t("carMaintenance.noVehicleSelected")}
      content={t("carMaintenance.enterPlateOrVin")}
    />
  );

  const NoMaintenance = () => (
    <EmptyState
      title={t("vehicleInspection.noMaintenanceRow")}
      content={t("vehicleInspection.addNewRecord")}
    />
  );
  const exportVehicle = () => {
    if (pageState.vehicleId === -1) {
      toggleOpen();
    } else {
      setLoading(true);
      VehicleInspectionService.list
        .exportVehicleInspection(tenant, pageState.vehicleId, form.getValues())
        .then((response) => {
          saveFileFromResponse(response);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          snackbar.show("error", t("missingEquipment.errors.actionError"));
        });
    }
  };
  const openDeleteModal = (vehicleInspection: any) => {
    toggleDelete();
    setCheckIsDelete("delete");
    setVehicleId(vehicleInspection);
  };

  const openEditModal = (vehicleInspection: any) => {
    toggleEdit();
    setVehicleId(vehicleInspection.id);
    setVehicleSelected(vehicleInspection);
  };
  const deleteVehicle = () => {
    setLoading(true);
    VehicleInspectionService.delete
      .deleteVehicle(tenant, vehicleId)
      .then((response) => {
        setLoading(false);
        snackbar.show(
          "success",
          t("vehicleInspection.deleteModal.successMessage")
        );
        setRefreshPage();
      });
  };
  useEffect(() => {
    if (pageState.vehicleId !== -1) {
      repairedStatusList();
    }
  }, [!refresh]);
  return (
    <Box>
      <form id="vehicle-inspection" onSubmit={form.handleSubmit(onSubmit)}>
        <GenericFilterBox formId="vehicle-inspection" onReset={() => onReset()}>
          <FormInput
            type="text"
            label={t("vehicleInspection.plate")}
            name={nameof<VehicleInspection.VehicleInspectionFilter>("plate")}
            formInstance={form}
            fullWidth
          />
          <FormInput
            type="text"
            label={t("vehicleInspection.vin")}
            name={nameof<VehicleInspection.VehicleInspectionFilter>("vin")}
            formInstance={form}
            fullWidth
          />

          {/* <FormInput
            type="date"
            label={t("vehicleInspection.inspectDataFrom")}
            name={nameof<VehicleInspection.VehicleInspectionFilter>(
              "inspectionDateFrom"
            )}
            inputFormat={"DD/MM/YYYY HH:mm"}
            ampm={false}
            value={form.watch('inspectionDateFrom')}
            onChange={(newTodayValue) => {
              form.setValue('inspectionDateFrom', newTodayValue);
          }}
            fullWidth
          />
          <FormInput
           type="date"
           fullWidth
           ampm={false}
           inputFormat={'DD/MM/YYYY HH:mm:ss'}
            label={t("vehicleInspection.inspectDataTo")}
            name={nameof<VehicleInspection.VehicleInspectionFilter>(
              "inspectionDateTo"
            )}
            value={form.watch('inspectionDateTo')}
            onChange={(newTodayValue) => {
              form.setValue('inspectionDateTo', newTodayValue);
          }}
          /> */}
        </GenericFilterBox>
      </form>
      <Box className="carGenericOuterTableBox">
        <Box className="carGenericTable">
          <Box>
            <Card>
              <Box
                minHeight={46}
                pr={1}
                display="flex"
                justifyContent={"flex-end"}
                alignItems="center"
              >
                <Mui.Grid item>
                  <Mui.Button
                    variant="text"
                    size="icon"
                    disabled={length === 0 ? true : false}
                    onClick={exportVehicle}
                    color="accent"
                  >
                    <Mui.Tooltip title={t("tooltipTitle.download")}>
                      <FileDownloadIcon />
                    </Mui.Tooltip>
                  </Mui.Button>
                </Mui.Grid>

                {hasScope("SCOPE_CREATE_MDVEHICLE_INSPECTION") && (
                  <Mui.Grid item>
                    <Mui.Button
                      color="accent"
                      variant="text"
                      size="icon"
                      disabled={pageState.vehicleId === -1}
                    >
                      <Mui.Tooltip title={t("tooltipTitle.add")}>
                        <AddIcon onClick={() => toggleCreate()} />
                      </Mui.Tooltip>
                    </Mui.Button>
                  </Mui.Grid>
                )}
              </Box>
            </Card>
          </Box>
          <Box>
            {pageState.vehicleId !== -1 ? (
              <Box>
                <Box component="div">
                  <Box className="heightForNoImage">
                    <AgGridOperationTable
                      columnDefs={vehicleColumns}
                      rowData={pageState.data}
                      totalElements={pageState?.data?.length}
					  rowModelType="clientSide"
                    />


                  </Box>
                </Box>
              </Box>
            ) : (
              <Box component="div">
                <Box component="div" className="heightForNoImage">
                  <AgGridOperationTable
                    columnDefs={vehicleColumns}
                    rowData={pageState.data}
                    totalElements={pageState?.data?.length}
					rowModelType="clientSide"
                  />

                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box></Box>
      {/* </CardContent>
      </Card> */}

      <ConfirmationModalTransportator
        onClose={checkIsDelete == "delete" ? toggleDelete : toggleOpen}
        setOpen={checkIsDelete == "delete" ? showDelete : open}
        title={
          checkIsDelete == "delete"
            ? t("vehicleInspection.deleteModal.title")
            : t("vehicleInspection.checkModal.title")
        }
        message={
          checkIsDelete == "delete"
            ? t("vehicleInspection.deleteModal.body")
            : t("vehicleInspection.checkModal.body")
        }
        cancel={t("actionButtons.close")}
        confirm={t("actionButtons.delete")}
        updateAction={deleteVehicle}
        checkIsDelete={checkIsDelete}
      />
      <CreateVehicleInspection
        onClose={toggleCreate}
        vehicleId={pageState.vehicleId}
        pageState={pageState.data}
        setRefresh={setRefreshPage}
        open={showCreate}
      />

      <EditVehcleInspection
        onClose={toggleEdit}
        open={showEdit}
        vehicleId={pageState.vehicleId}
        pageState={pageState.data}
        setRefresh={setRefreshPage}
        VehicleSelected={vehicleSelected}
        id={vehicleId}
      />
    </Box>
  );
};
